<template>
    <div>
        <swb-query-sort-area v-if="showQuery" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
        <div v-if="checkBox" class="table-layout mt10">
            <el-table ref="multipleTable" :data="msuList" border tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange">
                <el-table-column align="center" type="selection" :selectable="selectable" width="55"></el-table-column>
                <el-table-column width="55" align="center" prop="fileBrowseUrl" label="图片">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileBrowseUrl != null">
                            <img class="wh100" :src="scope.row.fileBrowseUrl"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="servcName" label="服务项目名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="服务名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="服务类型" align="left" width="120" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{servcTypeMap[rows.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务用途" width="100" align="center">
                    <template slot-scope="rows">
                        <span v-if="rows.row.comnOnlyFlag">常规服务</span>
                        <span v-else>维保服务</span>
                    </template>
                </el-table-column>
                <el-table-column width="100" prop="toDoorFee" label="上门费(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.toDoorFee != null">
                            <span>{{((rows.row.toDoorFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" label="参考人工费(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.workHourFee != null">
                            <span>{{((rows.row.workHourFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" label="参考价格(元)" align="right">
                    <template slot-scope="rows">
                        <div v-if="rows.row.generallFee != null">
                            <span>{{((rows.row.generallFee).toFixed(2)).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}}</span>
                        </div>
                        <div v-else>
                            <span>0.00</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="right" prop="wrntPeriod" label="质保期(天)" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" v-if="objectType != 2" align="center" prop="shelfState" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.shelfState == 0" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>未上架</span></el-tag>
                        <el-tag v-if="scope.row.shelfState == 1" type="success" style="background-color: transparent; border: none" close-transition>
                            <span>已上架</span></el-tag>
                        <el-tag v-if="scope.row.shelfState == -1" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>已下架</span>
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-layout" v-else>
            <el-table ref="multipleTable" :data="msuList" border style="width: 100%" highlight-current-row @current-change="handleCurrentChange">
                <el-table-column width="55">
                    <template slot-scope="rows">
                        <div class="copy-radio" :class="{'circle' : checlMsuInfo!= null && checlMsuInfo.id == rows.row.id}">
                            <div class="circle-dot"></div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="55" align="center" prop="fileBrowseUrl" label="图片">
                    <template slot-scope="scope">
                        <div v-if="scope.row.fileBrowseUrl != null">
                            <img class="wh100" :src="scope.row.fileBrowseUrl"/>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="servcName" label="服务项目名称" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column prop="title" label="服务名称" min-width="150" align="left" show-overflow-tooltip></el-table-column>
                <el-table-column label="服务类型" align="left" width="120" show-overflow-tooltip>
                    <template slot-scope="rows">
                        <span>{{servcTypeMap[rows.row.type]}}</span>
                    </template>
                </el-table-column>
                <el-table-column label="服务用途" width="100" align="center">
                    <template slot-scope="rows">
                        <span v-if="rows.row.comnOnlyFlag">常规服务</span>
                        <span v-else>维保服务</span>
                    </template>
                </el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="90" align="right" prop="toDoorFee" label="上门费(元)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="110" align="right" prop="workHourFee" label="参考人工费(元)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="90" align="right" prop="generallFee" label="服务费(元)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="90" align="right" prop="wrntPeriod" label="质保期(天)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="100" align="right" prop="rspTimeMi" label="响应时长(分钟)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="100" align="right" prop="arriveTimeMi" label="到达时长(分钟)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="100" align="right" prop="repairedTimeMi" label="修复时长(分钟)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="100" align="right" prop="telCallTimeMi" label="回询时限(分钟)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="120" align="right" prop="accPrice" label="配件价格下限(元)" show-overflow-tooltip></el-table-column>
                <el-table-column v-if="searchAuthServicer == null || !searchAuthServicer" width="120" align="right" prop="accPrice2" label="配件价格上限(元)" show-overflow-tooltip></el-table-column>
                <el-table-column width="100" v-if="objectType != 2 && (searchAuthServicer == null || !searchAuthServicer)" align="center" prop="shelfState" label="状态" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.shelfState == 0" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>未上架</span></el-tag>
                        <el-tag v-if="scope.row.shelfState == 1" type="success" style="background-color: transparent; border: none" close-transition>
                            <span>已上架</span></el-tag>
                        <el-tag v-if="scope.row.shelfState == -1" type="danger" style="background-color: transparent; border: none" close-transition>
                            <span>已下架</span></el-tag>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <div class="block pagination-layout">
            <el-pagination background class="mt10" :page-size="pageSize" :page-sizes="pageSizes" :current-page="pageNumber" :total="totalCount" @current-change="handlePageChange" @size-change="handleSizeChange" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
        </div>
    </div>
</template>


<script>

    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { getDefaultPageSizes } from '../../app.conf'

    import userApi from '../../api/user'
    import servcApi from '../../api/servc'

    let searchConfigData = {
        "queryFields": [{
            "type": "Text",
            "label": "服务项目名称",
            "code": "title",
            "valueType": "String",
            "basic": true
        }, {
            "type": "Select",
            "label": "服务类型",
            "code": "type",
            "valueType": 'Integer',
            "basic": true,
            "dataList": []
        }, {
            "type": "Select",
            "label": "服务用途",
            "code": "comnOnlyFlag",
            "valueType": 'Boolean',
            "basic": true,
            "dataList": [{
                "value": null,
                "label": "-全部-"
            }, {
                "value": "true",
                "label": "常规服务"
            }, {
                "value": "false",
                "label": "维保服务"
            }]
        }],
        "sortFields": []
    };

    export default {
        name: 'swb-msu-list-for-select',
        desc: '服务信息',
        props: {
            objectId: {
                type: Number,
                default: null
            },
            objectType: {
                type: Number,
                default: null
            },
            checkedIds: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            filter: {
                type: Object,
                default: function () {
                    return {};
                }
            },
            shelfState: {
                type: Number,
                default: null
            },
            checkBox: {
                type: Boolean,
                default: false
            },
            proxied: {
                type: Boolean,
                default: false
            },
            type: {
                type: Number,
                default: null
            },
            comnOnlyFlag: { // 服务用途
                type: Boolean,
                default: null
            },
            searchAuthServicer: {
                type: Boolean,
                default: null
            }
        },
        data: function () {
            return {
                pageNumber: 1,
                totalCount: 1,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                checked: true,
                msuList: [],
                checlMsuInfo: null,
                title: null,

                currentInfo: {},
                //复选信息
                checkedIdsX: [],
                checkedIdMap: {},
                checkedDelay: 100,
                checkedIniting: false,
                checkedTblRefId: 'multipleTable',
                checkedList: [],
                servcTypeMap: getEnumMap('servcType', 'value2text'),
                //
                queryConfig: null,
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                showQuery: true,
            }
        },
        created: function () {
            let self = this;
            self.pageSize = self.pageSizes.first();
            //
            let queryConfig = searchConfigData || {};
            let queryConfigMap = queryConfig.queryFields.toMap("code");
            let servcTypeList = [{
                value: null,
                label: '- 全部 -'
            }];
            let servcTypes = getEnumList("servcType");
            for(let i = 0; i < servcTypes.length; i++) {
                let item = servcTypes[i];
                let queryItem = {};
                queryItem.value = item.value;
                queryItem.label = item.text;
                servcTypeList.push(queryItem);
            }
            let servcTypeListItem = queryConfigMap["type"];
            servcTypeListItem.dataList = [];
            servcTypeListItem.dataList = Utils.merge([], servcTypeList);
            if(!Utils.isNoB(self.type)) {
                servcTypeListItem.hidden = true;
            }
            //
            let comnOnlyFlagItem = queryConfigMap["comnOnlyFlag"];
            if(!Utils.isNoB(self.comnOnlyFlag)) {
                comnOnlyFlagItem.hidden = true;
            }
            self.queryConfig = Utils.merge({}, queryConfig);
            //
            self.checkedIdsX = self.checkedIds.clone();
            this.checkedIdsX.forEach(function (id) {
                let msu = {};
                msu.ssuId = id;
                self.checkedList.add(msu);
            });
            self.getCurrentUserInfo();
        },
        methods: {
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }
                this.pageNumber = 1;
                this.getMsuList();
            },
            // ===================== 分页多选开始 ==============================
            addCheckId: function (id, val) {
                if(!this.checkedIdsX.contains(id)) {
                    this.checkedIdsX.add(id);
                    this.checkedList.add(val);
                    return id;
                }
                return null;
            },
            delCheckId: function (id) {
                let self = this;
                if(self.checkedIdsX.contains(id)) {
                    for(let i = 0; i < self.checkedList.length; i++) {
                        let checkedMsu = self.checkedList[i];
                        if(checkedMsu.ssuId == id) {
                            self.checkedList.splice(i, 1);
                        }
                    }
                    self.checkedIdsX.remove(id);
                    return id;
                }
                return null;
            },

            handleSelectionChange: function (selRows) {
                let self = this;
                if(self.checkedIniting) {
                    return;
                }
                let allIds = self.msuList.pluck("ssuId");
                let selIds = selRows.pluck("ssuId");
                selIds.forEach(function (id, index) {
                    self.addCheckId(id, selRows[index]);
                });

                let lesIds = Utils.compareArrays(selIds, allIds)["less"];
                lesIds.forEach(function (id, index) {
                    self.delCheckId(id);
                });
            },
            restoreSelRows(dataRows, tblRefId, idProp){
                let self = this;
                self.checkedIniting = true;
                idProp = idProp || "id";
                let allIds = dataRows.pluck(idProp);
                let selIds = Utils.compareArrays(allIds, this.checkedIdsX)["same"];
                selIds.forEach(function (id) {
                    self.toggleListRowById(dataRows, tblRefId, idProp, id);
                });
                //
                self.checkedIniting = false
            },

            hashCheckedId(id){
                return this.checkedIdsX.contains(id);
            },

            toggleListRowById(dataRows, tblRefId, idProp, idVal){
                let self = this;
                //
                idProp = idProp || "id";
                let refTbl = self.$refs[tblRefId];
                let theRow = dataRows.find(function (row, idx) {
                    return row[idProp] == idVal;
                });
                if(theRow != null) {
                    refTbl.toggleRowSelection(theRow);
                }
            },
            // ===================== 分页多选结束 ==============================
            //===========回显禁用===============
            selectable: function (row, index) {
                let self = this;
                let checkedIds = self.checkedIds;
                if(checkedIds.indexOf(row.ssuId) >= 0) {
                    return false;
                } else {
                    return true;
                }
            },
            //===========回显禁用结束===============
            getCurrentUserInfo: function () {
                let self = this;
                let postData = {};
                userApi.getUserInfoByContext(postData, function (result) {
                    if(result.type == "info") {
                        self.currentInfo = result.data;
                        self.getMsuList();
                    }
                });
            },
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                if(this.checkedIniting) {
                    return;
                } else {
                    this.checkedIniting = true;
                }

                this.pageNumber = val;
                this.getMsuList();
            },
            getMsuList: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber,
                };
                let queryModel = self.queryModel;
                let filterItem = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                let filterItems = Object.assign(filterItem, self.filter);
                if(self.proxied) {
                    filterItems.merchantId = self.currentInfo.scopeEntity.id;
                    filterItems.merchantType = self.currentInfo.scopeEntity.type;
                    filterItems.srcMerchantId = self.objectId || null;
                    filterItems.srcMerchantType = self.objectType;    // 供应商
                    if(this.searchAuthServicer != null) {
                        if(this.searchAuthServicer) {
                            filterItems.merchantId = null;
                            filterItems.merchantType = null;
                            filterItems.searchAuthServicer = true;
                            filterItems.authFlag = true;
                            filterItems.accepted = true;
                        } else {
                            filterItems.noAuthServicer = true;
                        }
                    }
                } else {
                    filterItems.merchantId = self.objectId;
                    filterItems.merchantType = self.objectType;
                    //
                    filterItems.authFlag = false;   // 非授权
                }

                if(!Utils.isNoB(self.shelfState)) {
                    filterItems.shelfState = self.shelfState;
                }
                if(!Utils.isNoB(self.type)) {
                    filterItems.type = self.type;
                }
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                let theLoad = MsgBox.loading();
                servcApi.getMsuPagedList(postData, function (result) {
                    theLoad.hide();
                    if(result.type == "info") {
                        let resultData = result.data;
                        self.msuList = resultData.rows;
                        let pagination = resultData.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;

                        setTimeout(function () {
                            self.restoreSelRows(self.msuList, self.checkedTblRefId, 'ssuId');
                        }, self.checkedDelay);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            handleCurrentChange: function (val) {
                this.checlMsuInfo = Utils.merge({}, val);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                //
                let checkBox = self.checkBox;
                if(checkBox) {
                    let multipleSelection = self.checkedList;
                    if(multipleSelection != null && multipleSelection.length > 0) {
                        result.type = 'info';
                        result.data = multipleSelection;
                    } else {
                        result.type = 'warn';
                        result.message = '至少选择一个服务！';
                    }
                } else {
                    let msuInfo = self.checlMsuInfo;
                    if(msuInfo != null) {
                        result.type = "info";
                        result.data = msuInfo
                    } else {
                        result.type = 'warn';
                        result.message = '请选择一个服务！';
                    }
                }
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/servc/MsuListForSelect.vue